module.exports = __webpack_public_path__ + "media/images/top/etc-card-2-a0af485361cf541cda66c03c82620a43.jpg";